import React, { useEffect } from "react";
import PalletSupplyImage from "web/assets/images/pallet-supply-image.webp";
import AOS from "aos";

import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/WhoItFor/PalletSupply/PalletSupplyStyled";

const PalletSupply = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="200">
      <Wrapper>
        <h1>
          Pallet supply. On your terms. No matter where you are, or how big you
          are.
        </h1>
        
        <h2>
          Whether you’re someone with a pickup truck and a few pallets in the
          bed, a pallet depot with big growth plans, or a national retailer
          trying to manage distribution, the PalletTrader marketplace is where
          you’ll find everything you need to take control of your pallet supply.
        </h2>
        <img src={PalletSupplyImage} alt="PalletSupplyImage" />
      </Wrapper>
    </Container>
  );
};

export default PalletSupply;
